module.exports = __webpack_public_path__ + "img/bmw-logo.670ea88b.webp";